import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { Observable, of } from "rxjs";
import { ICellRendererParams } from "@ag-grid-community/core";
import { FormatHistoryResult } from "@front/m19-services";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-activity-value",
  imports: [AsyncPipe],
  template: `@if (value$ | async; as value) {
    <div class="flex h-full justify-center">
      @if (value.dataType === "image") {
        <img class="h-full p-0.5" [src]="value.value" />
      } @else {
        <span>{{ value.value }}</span>
      }
    </div>
  }`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityValueComponent implements ICellRendererAngularComp {
  value$: Observable<FormatHistoryResult> = of();

  public agInit(params: ICellRendererParams<Observable<FormatHistoryResult>>): void {
    this.value$ = params.value;
  }

  public refresh(params: ICellRendererParams<Observable<FormatHistoryResult>>): boolean {
    this.agInit(params);

    return true;
  }
}
